import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.660474,0,0,0.660474,3.937248,1.974969)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,3L12,21",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.27px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.660474,0,0,0.660474,3.937248,1.974969)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3,12L21,12",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.27px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.660474,0,0,0.660474,4.604691,1.343299)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.405,8.456L20.405,17.456C20.405,19.94 18.388,21.956 15.905,21.956L6.489,21.956C4.006,21.956 1.989,19.94 1.989,17.456L1.989,8.456C1.989,5.973 4.006,3.956 6.489,3.956L15.905,3.956C18.388,3.956 20.405,5.973 20.405,8.456Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "2.27px",
					strokeMiterlimit: 1.5
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.522,21.474L21.433,21.474",
			style: {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: "1.5px",
				strokeMiterlimit: 1.5
			}
		})
	] })
});
export default SvgWindow;
